module.exports = __webpack_public_path__ + "static/API-b4eaa6c6e147e35dbc43582f3d8b4d3d.jpeg";